import { render, staticRenderFns } from "./workPattern.vue?vue&type=template&id=10f4a10f&scoped=true&"
import script from "./workPattern.vue?vue&type=script&lang=js&"
export * from "./workPattern.vue?vue&type=script&lang=js&"
import style0 from "./workPattern.vue?vue&type=style&index=0&id=10f4a10f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10f4a10f",
  null
  
)

export default component.exports